import { render } from "./Slide4.vue?vue&type=template&id=2e0fb7b1&scoped=true"
import script from "./Slide4.vue?vue&type=script&lang=js"
export * from "./Slide4.vue?vue&type=script&lang=js"

import "./Slide4.vue?vue&type=style&index=0&id=2e0fb7b1&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0fb7b1"]])

export default __exports__